import { useState, useEffect } from "react";

import Grid from "@mui/material/Grid";
import TableDisplay from "./TableDisplay";
import Paginator from "./Paginator";
import NoItemsReturned from "./NoItemsReturned";

import { sortData } from "../../Logic/sortData";

function TableWithPaginator({
  tableSettings,
  dataSettings,
  data,
  pageNumber,
  numResultsPerPage,
}) {
  // Derive paginator props
  const startIndex = (pageNumber - 1) * numResultsPerPage + 1;
  const endIndex = Math.min(pageNumber * numResultsPerPage, data.length);
  const numPages = Math.ceil(data.length / numResultsPerPage);
  const numItems = data.length;

  const paginatorProps = {
    pageNumber,
    numPages,
    startIndex,
    endIndex,
    numItems,
  };

  // Derive table props

  const [sortColumn, setSortColumn] = useState("priority"); // "priority" or null
  const [sortDescending, setSortDescending] = useState(false);
  const [sortedData, setSortedData] = useState(data);
  const [resultsInView, setResultsInView] = useState(
    sortedData.slice(startIndex - 1, endIndex)
  );

  useEffect(() => {
    const sortedData = sortData(sortColumn, sortDescending, data);

    setSortedData(sortedData);
    setResultsInView(sortedData.slice(startIndex - 1, endIndex));
  }, [sortColumn, sortDescending, data, endIndex, startIndex]);

  if (numItems === 0) {
    return (
      <Grid container sx={{ color: "text.primary" }}>
        <NoItemsReturned></NoItemsReturned>
      </Grid>
    );
  }

  return (
    <Grid container>
      <TableDisplay
        data={resultsInView}
        tableSettings={tableSettings}
        dataSettings={dataSettings}
        sortColumn={sortColumn}
        sortDescending={sortDescending}
        setSortColumn={setSortColumn}
        setSortDescending={setSortDescending}
      ></TableDisplay>
      <Paginator paginatorProps={paginatorProps}></Paginator>
    </Grid>
  );
}

export default TableWithPaginator;
